/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
* */

import AccordianFaq from "./AccordianFaq.container";

export default AccordianFaq;
